import { useState, useEffect, useCallback } from 'react';
import axiosInstance from '../../../api/axiosInstance';

export default function useMigrationJobs(pollInterval = 30000) {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchJobs = useCallback(async () => {
    try {
      const response = await axiosInstance.get('/api/business/email-migration/jobs');
      if (response.data.success) {
        setJobs(response.data.jobs || []);
      }
      setError(null);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  // Poll faster while a migration is running so progress moves in the list
  const hasRunning = jobs.some(j => j.status === 'running');

  useEffect(() => {
    fetchJobs();
    const interval = setInterval(fetchJobs, hasRunning ? 5000 : pollInterval);
    return () => clearInterval(interval);
  }, [fetchJobs, pollInterval, hasRunning]);

  return { jobs, loading, error, refresh: fetchJobs };
}
